(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["breadcrumbs"] && !Shopify.designMode) return;
  try {
    (() => {
    // Show the mobile fade only while part of the trail is hidden to the right.
    const update = (list) => {
      const hidden = list.scrollWidth - list.clientWidth - list.scrollLeft;
      list.classList.toggle('is-overflowing', hidden > 1);
    };

    const init = () => {
      document.querySelectorAll('.nf-breadcrumbs__list:not([data-fade-ready])').forEach((list) => {
        list.dataset.fadeReady = '';
        update(list);
        list.addEventListener('scroll', () => update(list), { passive: true });
        new ResizeObserver(() => update(list)).observe(list);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
